// extracted by mini-css-extract-plugin
module.exports = {"link":"FooterNavLink_link__tUEMu","link__icon":"FooterNavLink_link__icon__DIudh"};